import { create } from 'zustand';
import { apiService } from "../../services/api";
import { DateRangeFilter, WorkspaceType } from 'shared-types';
import { SpaceAssign } from 'shared-types/spaceAssignment';

interface ReportState {
  report: SpaceAssign[];
  count: number;
  occupancyRate: number;
  // CRUD actions
 getOccupancyReport: (type: WorkspaceType, dateRange: DateRangeFilter) => Promise<{
    count: number;
    data: SpaceAssign[];
    occupancyRate: number;
}>;
}
export const useReportStore = create<ReportState>((set) => ({
report: [],
count: 0,
occupancyRate: 0,
  getOccupancyReport: async (type,dateRange) => {
    try {
      const response = await apiService.get(`occupancy/report`, {
        params: {
          workspaceType: type,
          startDate: dateRange.startDate,
          endDate: dateRange.endDate
        }
      })
      
      set({report: response.data.data, count: response.data.count, occupancyRate: response.data.occupancyRate});
      return response.data;
    } catch (error) {
      console.error('Error fetching occupancy report:', error);
      throw error;
    }
  },
}));